import React from 'react'
import styled from 'styled-components'

interface Props {
  handled: number
  total: number
  size: 'panel' | 'pill'
}

export const ProgressRing: React.FC<Props> = ({ handled, total, size }) => {
  const pct = total > 0 ? Math.round((handled / total) * 100) : 0

  return (
    <Ring $size={size} $pct={pct} aria-hidden={true}>
      <Hole $size={size}>{size === 'panel' ? `${handled}/${total}` : null}</Hole>
    </Ring>
  )
}

const Ring = styled.div<{ $size: 'panel' | 'pill'; $pct: number }>`
  position: relative;
  flex: 0 0 auto;
  width: ${({ $size }) => ($size === 'panel' ? '2.75rem' : '1.375rem')};
  height: ${({ $size }) => ($size === 'panel' ? '2.75rem' : '1.375rem')};
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  background: ${({ theme, $pct }) =>
    `conic-gradient(${theme.colors.success} 0% ${$pct}%, ${theme.colors.primary}33 ${$pct}% 100%)`};
`

const Hole = styled.div<{ $size: 'panel' | 'pill' }>`
  width: ${({ $size }) => ($size === 'panel' ? '2.125rem' : '1rem')};
  height: ${({ $size }) => ($size === 'panel' ? '2.125rem' : '1rem')};
  border-radius: 50%;
  background: ${({ theme }) => theme.colors.menuBg};
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: ${({ theme }) => theme.fontSize.xs}rem;
  font-weight: 700;
  color: ${({ theme }) => theme.colors.neutralWhite};
  font-family: 'Roboto Mono', ui-monospace, monospace;
  font-variant-numeric: tabular-nums;
`
